import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';

// #region Styles
const StyledHeadline = styled(Typography.Headline)`
    color: ${ColorBrandBlue1};
`;

const SectionName = styled(Typography.Body)`
    margin-bottom: 0;
`;
// #endregion Styles

function HeaderSection({ headline, sectionName }: { headline: string; sectionName?: string }) {
    return (
        <Flex.Column gap="0">
            <SectionName>{sectionName || ''}</SectionName>
            <StyledHeadline forwardedAs="h1" size="L">
                {headline}
            </StyledHeadline>
        </Flex.Column>
    );
}

export default withErrorBoundary(HeaderSection, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
